// ── L'envoi d'une demande, avec sa progression (fetch ne donne pas la progression d'un envoi) ──

export interface SendResult {
  /** 0 si la connexion a echoue */
  status: number;
  data: { number?: number; error?: string };
}

export function postForm(url: string, form: FormData, onProgress: (loaded: number, total: number) => void): Promise<SendResult> {
  return new Promise(resolve => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.responseType = 'json';
    xhr.upload.onprogress = e => { if (e.lengthComputable) onProgress(e.loaded, e.total); };
    xhr.onload = () => resolve({ status: xhr.status, data: (xhr.response ?? {}) as SendResult['data'] });
    xhr.onerror = () => resolve({ status: 0, data: {} });
    xhr.send(form);
  });
}
